import { render } from "./AdminAccountManager.vue?vue&type=template&id=464d0a1c"
import script from "./AdminAccountManager.vue?vue&type=script&lang=js"
export * from "./AdminAccountManager.vue?vue&type=script&lang=js"
script.render = render

export default script